import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'SMS',
  details:
    'Invoice summary sent via mobile text message including a payment link.',
  label: 'Mobile Number',
})
